export default {
    /*Tabs.jsx*/
    message_1_01: "Select Range:",
    message_1_02: "Day",
    message_1_03: "Week",
    message_1_04: "Month",
    message_1_05: "Smartphone",
    message_1_06: "Tablets",
    message_1_07: "Notebooks",
    /*Analytics.jsx*/
    message_2_01: "Overview",
    message_2_02: "Total Visitors",
    message_2_03: "New Users",
    message_2_04: "Returning Users",
    message_2_05: "This Last 24 Hours",
    message_2_06: "This Last Week",
    message_2_07: "This Last Month",
    message_2_08: "Operating System",
    message_2_09: "Data Download vs Upload",
    message_2_10: "Smartphone, Tablets, Notebooks",
    message_2_11: "New vs Returning Users",
    message_2_12: "Total Visits",
    message_2_13: "Loading",
    /*App.jsx*/
    message_3_01: "Reset",
    message_3_02: "Analytics",
    message_3_03: "Settings",
    message_3_04: "FAQs",
    message_3_05: "Languages",
    message_3_06: "Log out",
    /*RegistrationState.jsx*/
    message_4_01: "Reset",
    message_4_02: "Details",
    message_4_03: "Settings",
    message_4_04: "Branding",
    message_4_05: "Complete",
    /*DetailsState.jsx*/
    message_5_01: "Please introduce your company name and type of business",
    message_5_02: "",
    message_5_03: "Business name",
    message_5_04: "Type of business",
    message_5_05: "Customize your Wi-Fi service or click skip to use standard settings. You can come back and edit these at a later date.",
    message_5_06: "Skip",
    message_5_07: "Continue",
    message_5_08: "Please enter Business Name",
    message_5_09: "Your Business Name should not exceed {ruleValue} characters",
    message_5_10: "Please select your Business Type",
    message_5_11: "Pub",
    message_5_12: "Restaurant",
    message_5_13: "Bookshop",
    message_5_14: "Clothes store",
    message_5_15: "Shoe shop",
    message_5_16: "Store",
    message_5_17: "Coffee shop",
    message_5_18: "Supermarket",
    message_5_19: "Garden centre",
    message_5_20: "Garage",
    message_5_21: "Pharmacy",
    message_5_22: "Hotel",
    message_5_23: "Architect",
    message_5_24: "General practice",
    message_5_25: "Dentist practice",
    message_5_26: "Hairdresser",
    message_5_27: "Beauty salon",
    message_5_28: "Other",
    /*SettingsState.jsx*/
    message_6_01: "Manage your Wi-Fi settings",
    message_6_02: "Time of free Wi-Fi",
    message_6_03: "Choose how much free Wi-Fi time you want to offer to your customers",
    message_6_04: "Time of free Wi-Fi",
    message_6_05: "No limit",
    message_6_06: "15 minutes",
    message_6_07: "30 minutes",
    message_6_08: "1 hour",
    message_6_09: "2 hours",
    message_6_10: "4 hours",
    message_6_11: "Social Media Links",
    message_6_12: "Social media links",
    message_6_13: "Back",
    message_6_14: "Next",
    message_6_15: "Please select the Time of free Wi-Fi",
    message_6_16: "Invalid URL format for Facebook Link",
    message_6_17: "Invalid URL format for Twitter Link",
    message_6_18: "Invalid URL format for Foursquare Link",
    /*BrandingState.jsx*/
    message_7_01: "Customise the Welcome screen to match your brand",
    message_7_02: "Wi-Fi Service Name - e.g. Welcome to Louis' Bar",
    message_7_03: "Customise the name of the Wi-Fi that is shown to customers",
    message_7_04: "Wi-Fi name",
    message_7_05: "Address of your website",
    message_7_06: "Add your website",
    message_7_07: "Address of your website",
    message_7_08: "Background",
    message_7_09: "Upload your own image, or choose an image to use as your background",
    message_7_10: "No background image",
    message_7_11: "Advertising",
    message_7_12: "Upload your own advert",
    message_7_13: "Upload Ad",
    message_7_14: "Back",
    message_7_15: "Next",
    message_7_16: "Please enter Wi-Fi Name",
    message_7_17: "Your Wi-Fi Name should not exceed {ruleValue} characters",
    message_7_18: "Please enter Merchant's own URL",
    message_7_19: "Invalid URL format for Merchant's own URL",
    message_7_20: "Preview",
    message_7_21: "Upload your own image",
    message_7_22: "Please upload an image",
    /*CompleteState.jsx*/
    message_8_01: "Congratulations,",
    message_8_02: "you are almost done",
    message_8_03: "Please click",
    message_8_04: "SETTINGS",
    message_8_05: "Save",
    message_8_06: "to apply changes to your portal.",
    message_8_07: "to change this at a later date",
    message_8_08: "SAVE",
    message_8_09: "You can always go back to your",
    message_8_10: "you are done",
    message_8_11: "Now you can use your default portal.",
    message_8_12: "Your changes have been saved",
    /*SaveConfirmation.jsx*/
    message_9_01: "By clicking",
    message_9_02: "Continue",
    message_9_03: "you are choosing to override default Proximus template and apply your own chosen settings to this portal.",
    message_9_04: "Cancel",
    message_9_05: "Your changes have been saved and applied to the portal.",
    message_9_06: "OK",
    message_9_07: "Something went wrong. Please try to logout / login and repeat your actions or contact Proximus",
    message_9_08: "OK",
    /*RedirectToManagementConsoleConfirmation.jsx*/
    message_10_01: "You are going to leave the CBU Portal Set-up assistant. By clicking",
    message_10_02: "Save And Continue",
    message_10_03: "you are choosing to override default template and apply your own chosen settings to this portal. By clicking",
    message_10_04: "Cancel",
    message_10_05: "you are choosing to reset all settings to default.",
    message_10_06: "Something goes wrong. Please try to logout / login and repeat your actions or contact your provider",
    message_10_07: "OK",
    /*ConfirmReset.jsx*/
    message_11_01: "By clicking",
    message_11_02: "Continue",
    message_11_03: "you are choosing to remove your custom settings and portal will be reverted back to original settings.",
    message_11_04: "Cancel",
    /*Splash.jsx*/
    message_12_01: "Welcome to our free WiFi access!",
    message_12_02: "We are offering you a fast and free wifi",
    message_12_03: "Connect",
    message_12_04: "Create your free account. Please enter your mobile number",
    message_12_05: "Mobile number",
    message_12_06: "I agree with the",
    message_12_07: "Terms and Conditions",
    message_12_08: "and",
    message_12_09: "Privacy Policy",
    message_12_10: "Register",
    message_12_11: "I already have a PIN code",
    message_12_12: "Powered by",
    /*Verification.jsx*/
    message_13_01: "Activate your account",
    message_13_02: "Please enter the PIN code you received on:",
    message_13_04: "PIN",
    message_13_05: "Login",
    message_13_06: "Change number",
    message_13_07: "New PIN code",
    message_13_08: "Powered by",
    /*Loading.jsx*/
    message_14_01: "Connecting, please wait...",
    /*Interstitial.jsx*/
    message_15_01: "Click this message",
    message_15_02: "or wait 5 seconds...",
    /*Success.jsx*/
    message_16_01: "Welcome to our free WiFi access!",
    message_16_02: "",
    message_16_03: "Congratulations, you are now connected",
    message_16_04: "Enjoy your free Internet !",
    message_16_05: "Powered by",
    /*PreviewWindow.jsx*/
    message_17_01: "Customized Wi-Fi User Journey",
    message_17_02: "Registration",
    message_17_03: "Verify",
    message_17_04: "Loading",
    message_17_05: "Advertising",
    message_17_06: "Success",
    /*OperatingSystem.jsx*/
    message_18_01: "Other",
    /*TotalVisits.jsx*/
    message_19_01: "Total Visits",
    /*DataDownloadVsUpload.jsx*/
    message_20_01: "Downloaded",
    message_20_02: "Uploaded",
    /*NewVsReturning.jsx*/
    message_21_01: "New users",
    message_21_02: "Returning users",
    /*ImageUploadContainer.jsx*/
    message_22_01: "Delete Advert",
    message_22_02: "Choose File",
    /*BackgroundImageUploadContainer.jsx*/
    message_23_01: "Delete Background",
    message_23_02: "Choose File",
    message_23_03: "Images will be automatically resized by the captive portal",
    message_23_04: "Use an image with landscape orientations",
    message_23_05: "Ensure the image is not low resolution",
    message_23_06: "Recommended image dimensions 1280 x 720",
    message_23_07: "Filename cannot exceed 45 characters"
};


// WEBPACK FOOTER //
// ./src/locales/en.js